import { render, staticRenderFns } from "./SetBasket.vue?vue&type=template&id=3a851bbc&scoped=true&"
import script from "./SetBasket.vue?vue&type=script&lang=js&"
export * from "./SetBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a851bbc",
  null
  
)

export default component.exports